import React, { useState } from "react";
import Label from "./Common/Label";
import { Link } from "react-router-dom";
import RowContainer from "./Common/RowContainer";
import Container from "./Common/Container";
import HorizontalSpace from "./HorizontalSpace";
import editIcon from "../assets/editIcon.svg";
import deleteIcon from "../assets/deleteIcon.svg";
import Switch from "./Common/Switch";
import styled from "styled-components";
import CustomCheckbox from "./Common/CustomCheckbox";

interface Member {
  id: number;
  srNo: number;
  name: string;
  lastname: string;
  email: string;
  membership: string;
  since: string;
  until: string;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  onCheckboxChange: (id: number) => void;
  isChecked: boolean;
  status: boolean;
  onStatusChange: (id: number) => void;
}

const NewRowContainer = styled(RowContainer)`
  overflow: hidden;
`;

const NewLabel = styled(Label)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const MembershipUser: React.FC<Member> = ({
  id,
  srNo,
  name,
  lastname,
  email,
  membership,
  since,
  until,
  onEdit,
  onDelete,
  onCheckboxChange,
  isChecked,
  status,
  onStatusChange,
}) => {
  const [isSwitchOn, setIsSwitchOn] = useState(status);
  const toggleSwitch = () => {
    const newStatus = !isSwitchOn;
    setIsSwitchOn(newStatus);
    onStatusChange(id);
  };

  const handleDelete = () => {
    onDelete(id);
  };

  return (
    <Container
      bgColor="#fff"
      borderRadius="10px"
      height="50px"
      alignItems="center"
      display="flex"
      width="100%"
      className="user-data user-container-hover"
    >
      <RowContainer
        justifyContent="space-between"
        alignItem="center"
        borderRadius="12px"
        margin="10px"
      >
        {/* 2.5 */}
        <RowContainer flex="0.7">
          {/* <CustomCheckbox
            checked={isChecked}
            onChange={() => onCheckboxChange(id)}
          /> */}
        </RowContainer>
        <NewRowContainer flex="2" gap="0px">
          <NewLabel fontWeight={400} fontSize="16px" color="#201F29">
            {srNo}
          </NewLabel>
        </NewRowContainer>
        <NewRowContainer flex="4" gap="0px">
          <NewLabel fontSize="16px" fontWeight={400}>
            {name}
          </NewLabel>
        </NewRowContainer>
        <NewRowContainer flex="4" gap="0px">
          <NewLabel fontSize="16px" fontWeight={400}>
            {lastname}
          </NewLabel>
        </NewRowContainer>
        <NewRowContainer flex="7">
          <NewLabel fontSize="16px" fontWeight={400}>
            {email}
          </NewLabel>
        </NewRowContainer>
        {/* <NewRowContainer flex="5" alignItem="center" gap="20px">
          {membership ? (
            <NewLabel
              fontSize="10px"
              color="#100F15"
              fontWeight={400}
              cursor="pointer"
              padding="8px 13px 8px 13px"
              bgColor="#DAD7FE"
              justifyContent="center"
              display="flex"
              width="90px"
              borderRadius="40px"
            >
              {membership}
            </NewLabel>
          ) : (
            <NewLabel
              fontSize="10px"
              color="rgba(255, 165, 82, 1)"
              fontWeight={400}
              cursor="pointer"
              padding="8px 13px 8px 13px"
              bgColor="#DAD7FE"
              justifyContent="center"
              display="flex"
              width="90px"
              borderRadius="40px"
            >
              {membership}
            </NewLabel>
          )}
        </NewRowContainer> */}

        <NewRowContainer flex="4">
          <NewLabel fontSize="16px" fontWeight={400}>
            {since}
          </NewLabel>
        </NewRowContainer>
        <NewRowContainer flex="4">
          <NewLabel
            fontSize="16px"
            fontWeight={400}
            style={{ color: isSwitchOn ? "#28A138" : "#EB002C" }}
          >
            {until}
          </NewLabel>
        </NewRowContainer>
        <RowContainer flex="3">
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <Switch isOn={isSwitchOn} onToggle={toggleSwitch} />
            <div style={{ cursor: "pointer" }}>
              <img
                src={editIcon}
                onClick={() => onEdit(id)}
                style={{ WebkitUserSelect: "none", userSelect: "none" }}
              />
            </div>
            {/* <div style={{ cursor: "pointer" }} onClick={handleDelete}>
              <img src={deleteIcon} style={{ WebkitUserSelect: "none", userSelect: "none" }}/>
            </div> */}
          </div>
        </RowContainer>
      </RowContainer>
    </Container>
  );
};
export default MembershipUser;
